<template>
  <div class="device-content">
    <el-form label-postion="left" label-width="80px">
      <el-form-item label="设备名称">
        <span>{{ name }}</span>
      </el-form-item>
      <el-form-item label="当前策略">
        <span>{{ stg_name }}</span>
      </el-form-item>
      <el-form-item label="修改策略">
        <el-select v-model="stg_id" placeholder="请选择">
          <el-option
            v-for="item in strategyOptions"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="控制模式">
        <el-switch
          v-model="ms"
          active-text="自动"
          inactive-text="手动"
          :active-value="0"
          :inactive-value="1"
          inactive-color="gray"
          @change="manualChange = true"
        ></el-switch>
      </el-form-item>
      <el-form-item label="亮度设置" v-if="ms">
        <el-slider
          v-model="light"
          :min="0"
          :max="100"
          show-input
          @change="manualChange = true"
        ></el-slider>
      </el-form-item>
      <el-button type="primary" @click="parseDeviceInfo">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </el-form>
  </div>
</template>
<script>
import lightListApi from "@/api/light/lightList";
import strategyApi from "@/api/light/strategy";
export default {
  name: "Device",
  props: {
    setData: {
      type: Object,
    },
  },
  data() {
    return {
      manualChange: false,
      type: this.setData.type,
      name: this.setData.name,
      light: this.setData.light,
      stg_id: this.setData.stg_id,
      stg_name: this.setData.stg_name,
      ms: this.setData.ms,
      strategyOptions: [],
      updateInfo: {
        lamp_id: this.setData.lamp_id,
        light: 0,
        stg_id: 0,
        ms: 0,
        type:1
      },
    };
  },
  methods: {
    getStyList() {
      strategyApi.strategyList({ page: 1, pageSize: 200, type: this.type }).then((res) => {
        if (res.data.code === 1000) {
          this.strategyOptions = res.data.data.list;
        }
      });
    },
    parseDeviceInfo() {
      this.updateInfo.light = this.light;
      this.updateInfo.ms = this.ms;
      if (this.stg_id) {
        this.updateInfo.stg_id = this.stg_id;
        this.updateLightStrategy();
      } else {
        this.$message.error("请选择策略!");
      }
    },
    updateLightStrategy() {
      this.updateInfo.type = this.type
      lightListApi
        .lightStrategysSave(this.updateInfo.lamp_id, this.updateInfo)
        .then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("更改成功！");
            if (this.updateInfo.ms === 1) {
              // 1手动
              this.lightContorl();
            }
            this.$parent.closeSet();
          }else{
            this.$message.error(res.data.message)
          }
        });
    },
    lightContorl() {
      let sendData = {
        light: this.updateInfo.light,
        type: this.type
      };
      lightListApi
        .lightControl(this.updateInfo.lamp_id, sendData)
        .then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("下发成功");
          }else{
            this.$message.error(res.data.message)
          }
        });
    },
    cancel() {
      this.$parent.closeSet();
    },
  },
  created() {
    this.getStyList();
  },
};
</script>
<style lang='less' scoped>
</style>